import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";
// import { publicIconPath } from "$utils/constants";

const useJssStyles = createUseStyles(() => ({
  search: {
    flex: 1,
    display: "flex",
    position: "relative",
    marginRight: theme.spacing(2),
    alignItems: "center",
  },
  searchIcon: {
    padding: [theme.spacing(0), theme.spacing(2)],
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    flex: "0 1 500px",
    margin: [0, 14],
    display: "flex",
  },
  inputInput: {
    padding: theme.spacing(1),
    paddingRight: 0,
    paddingLeft: `${theme.spacing(6)}px`,
    width: "100%",
    fontSize: 14,
    height: 36,
    fontFamily: `${theme.font.workSans}`,
    color: theme.color.gray5,
    background: theme.color.gray1,
    border: "none",
    "&:focus": {
      outline: "none",
      background: theme.color.white,
      border: `1px solid ${theme.color.gray5}`,
      color: theme.color.black,
    },
  },
  iconImg: {
    position: "absolute",
    left: 24,
    zIndex: 1,
  },
}));

export default function PrimarySearchAppBar() {
  const classes = useJssStyles();

  return <div className={classes.search} />;
}
